<script lang="ts">
	import './global.scss';
	import Modal from "svelte-simple-modal";
	import Content from "./Content.svelte";
	import { setupI18n, isLocaleLoaded } from './services/i18n';

	declare var lang: string; //this is specified in the index.html file to change the language

	$: if (!$isLocaleLoaded) {
		setupI18n({ withLocale: lang });
	}

</script>

	<svelte:options immutable/>
{#if $isLocaleLoaded}
	<Modal>
		<Content></Content>
	</Modal>

{/if}

